<template>
    <div>
        <OpenIndicator class="vs__open-indicator" />
    </div>
</template>

<script>
import OpenIndicator from '../../assets/icons/arrow_drop_down.svg?inline'

export default {
    components: {
        OpenIndicator
    }
}
</script>

<style scoped>
div
{
    transform: none !important;
    height: 100%;
    display: flex;
	padding-inline: .3125rem;
    align-items: center;
	border-left: 1px solid var(--bft-blue-200);
}
</style>
